import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.company || initialState;

export const selectCompany = createSelector([selectSlice], state => state);

export const selectCompanyListState = createSelector(
  [selectCompany],
  state => ({
    ...state.companyList,
    companiesArr: [...state.companyList.companiesArr].sort((a, b) =>
      a.name.localeCompare(b.name),
    ),
  }),
);

export const selectCompanies = createSelector(
  [selectCompanyListState],
  companyList => companyList.companiesArr,
);

export const selectConfirmedCompanies = createSelector(
  [selectCompanies],
  companiesArr =>
    companiesArr
      .filter(company => company.accepted)
      .sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectCompanyFormState = createSelector(
  [selectCompany],
  state => state.companyForm,
);

export const selectShareCompanyFormState = createSelector(
  [selectCompany],
  state => state.shareCompanyForm,
);

export const selectCompanyDetails = createSelector(
  [selectCompany],
  state => state.companyDetails,
);

export const selectCompanyStatus = createSelector(
  [selectCompany, selectSelectedEnvId],
  (state, envId) => {
    const isAccepted = Boolean(
      state.companyDetails.company?.companyHiikoEnvironments.find(
        env => env.hiikoEnvironment.id === envId,
      )?.accepted,
    );
    return isAccepted;
  },
);

export const selectSelectedCompanyId = createSelector(
  [selectCompany],
  state => state.selectedCompanyId,
);

export const selectSelectedCompanyName = createSelector(
  [selectCompany],
  state =>
    state.companyList.companiesArr.find(
      company => company.id === state.selectedCompanyId,
    )?.name || '',
);

export const selectSelectedCompanyGroupId = createSelector(
  [selectCompany],
  state => state.selectedCompanyGroupId,
);

// SELECTOR WITH VARIABLE EXAMPLE

// const getCompanyIdFromProps = (_, companyId: number | undefined) => {
//   return companyId;
// };

// export const selectCompanyById = createSelector(
//   [getCompanyIdFromProps, selectCompanies],
//   (id: number | undefined, companies) => {
//     return companies.find(company => company.id === id);
//   },
// );
